import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';

angular.module('ui-ng-calendar').factory('getCSSClassForString', function getCSSClassForString() {
  const MEMOIZED_COLOR_NKS = {};
  var cssCounter = 1;

  return function (name: string, colorLocation: string): string {
    if (cssCounter > 10) {
      cssCounter = 1;
    }

    if (!MEMOIZED_COLOR_NKS[name]) {
      MEMOIZED_COLOR_NKS[name] = `clr-${cssCounter}`;
      cssCounter++;
    }

    return `${MEMOIZED_COLOR_NKS[name]}-${_.isString(colorLocation) ? colorLocation : 'bkg'}`;
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/functions/get_css_class.ts